window.addEventListener("DOMContentLoaded", ()=>{
    const contactForm = document.getElementById("contact");
    if (contactForm) {
        const handleContactSubmit = function(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const successContainer = e.target.querySelector(".submit-message");
            fetch("/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(formData).toString()
            }).then(()=>{
                console.log("Form submit successful.");
                const formRows = e.target.querySelectorAll(".form-row");
                formRows.forEach((row)=>{
                    row.remove();
                });
                if (successContainer) {
                    successContainer.innerText = "Form sent successfully. Thank you!";
                    successContainer.classList.remove("inactive");
                }
            }).catch((error)=>{
                alert(error);
            });
        };
        contactForm.addEventListener("submit", handleContactSubmit);
        document.querySelectorAll("input, textarea").forEach((input)=>{
            input.addEventListener("focus", ()=>{
                input.labels.forEach((label)=>{
                    label.classList.add("focused");
                });
            });
            input.addEventListener("blur", ()=>{
                input.labels.forEach((label)=>{
                    label.classList.remove("focused");
                });
            });
        });
    }
});

//# sourceMappingURL=index.67dc5712.js.map
